import { Playground, PLAYGROUNG_BG_CHECKERBOARD } from '../../../components/playground/Playground';
import { PlaygroundClasses } from '../../../components/playground/PlaygroundClasses';
import { Headline } from '../../../components/Headline';

import { numbers } from '../../../utils/numbers';

export const Opacity = () => (
    <div>
        <Headline anchor='opacity'>Opacity</Headline>
        <Playground example={opacityExample} classes={opacityClasses} background={PLAYGROUNG_BG_CHECKERBOARD} />
        <Headline anchor='hover-opacity' headlineType='h3'>
            Hover opacity
        </Headline>
        <Playground
            example={opacityHoverExample}
            classes={opacityHoverClasses}
            background={PLAYGROUNG_BG_CHECKERBOARD}
        />
    </div>
);

const opacityExample = (
    <div className='display-flex flex-wrap gap-10'>
        {numbers.from_0_to_100.map((value, index) => (
            <div
                className={`width-50 aspect-ratio-1 display-grid place-items-center bg-info rounded opacity-${value}`}
                key={index}
            >
                {value}
            </div>
        ))}
    </div>
);

const opacityClasses = <PlaygroundClasses prefix='opacity-' classes={numbers.from_0_to_100} />;

const opacityHoverExample = (
    <div className='display-flex flex-wrap gap-10'>
        {numbers.from_0_to_100.map((value, index) => (
            <div
                className={`
                    width-50 aspect-ratio-1 display-grid place-items-center bg-info rounded
                    opacity-${value === '0' ? 100 : 110 - value}
                    hover-opacity-${value}
                `}
                key={index}
            >
                {value}
            </div>
        ))}
    </div>
);

const opacityHoverClasses = <PlaygroundClasses prefix='hover-opacity-' classes={numbers.from_0_to_100} />;
